/**
 *
 *
 */

import { useEffect, useState } from 'react';
import moment from 'moment';
import { Pagination } from 'components';
import { stringToMoneyFormat } from 'utils';
import { Link } from 'react-router-dom';
import { Table, Empty, Image, Switch, Tag } from 'antd';
import styled from 'styled-components';
import { PictureOutlined } from '@ant-design/icons';
import {
  PRODUCT_TYPE,
  PRODUCT_STATUS,
  APPLICATION_STATUS,
} from 'constants/ProductConstants';

/**----------------------------------------
 * [Component] 총관리자: 상품목록 > 상품목록테이블
 * ----------------------------------------
 */
const ProductList = ({
  products,
  currentPage,
  isCheckedAll,
  checkedList,
  onPagination,
  onChecked,
  onCheckedAll,
  onToggle,
  pagenationInformation,
  currentShop,
  listQuery,
}) => {
  /* ===== STATE ===== */
  const [productList, setProductList] = useState([]);

  /* ===== HOOKS ===== */
  useEffect(() => {
    if (Array.isArray(products)) {
      setProductList(
        products.map((product, index) => {
          const thumbnailFile = Array.isArray(product.product_file)
            ? product.product_file.find((item) => item.type === 'THUMBNAIL')
            : '';
          const thumbnailUrl = thumbnailFile
            ? `${process.env.REACT_APP_STORE_URL}/${thumbnailFile.file_url}`
            : '';

          return {
            // ...product,
            key: product.product_id,
            no: index + 1,
            category: product.product_category.product_category_name,
            code: product.product_code,
            image: thumbnailUrl,
            name: product.product_name,
            num: product.num,
            price: product.price,
            created: moment.unix(product.created_at).format('YYYY-MM-DD'),
            type: product.type,
            best: product.is_best,
            new: product.is_new,
            brand: product.is_show_brand,
            amount: product.is_amount,
            application: product.application_status,
            status: product.product_status,
          };
        }),
      );
    }
  }, [products]);

  const col = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
      width: 80,
      align: 'center',
      // fixed: 'left',
    },
    {
      title: '상품구분',
      dataIndex: 'category',
      key: 'category',
      width: 160,
      align: 'center',
      // fixed: 'left',
    },
    {
      title: '상품코드',
      dataIndex: 'code',
      key: 'code',
      width: 120,
      align: 'center',
      // fixed: 'left',
      render: (v) => (
        <span style={{ fontSize: '0.85em', opacity: 0.75 }}>{v}</span>
      ),
    },
    {
      title: '상품 이미지',
      dataIndex: 'image',
      key: 'image',
      width: 110,
      align: 'center',
      // fixed: 'left',
      render: (item) => {
        return (
          <div
            style={{
              textAlign: 'center',
              background: '#fdfdfd',
              borderRadius: 5,
              // height: '100%',
              border: '0.5px solid #f1f1f1',
              height: 62,
            }}
          >
            {item ? (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: 5,
                  backgroundImage: `url("${item}")`,
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  // backgroundSize: '85%',
                }}
              ></div>
            ) : (
              <div style={{ margin: '9px 0', opacity: 0.4 }}>
                <PictureOutlined style={{ fontSize: 20 }} />
                <p style={{ fontSize: '0.85em' }}>No image</p>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: '상품명',
      dataIndex: 'name',
      key: 'name',
      width: 380,
      align: 'center',
      // fixed: 'left',
      render: (item, product) => {
        return (
          <Link to={`/product/list/${product.key}?${listQuery}`}>
            {item}
          </Link>
        );
      },
    },
    {
      title: '재고수량',
      dataIndex: 'num',
      key: 'num',
      width: 130,
      align: 'center',
      render: (item) => `${stringToMoneyFormat(item)}EA`,
    },
    {
      title: '판매가',
      dataIndex: 'price',
      key: 'price',
      width: 135,
      align: 'center',
      render: (item) => `${stringToMoneyFormat(item)}원`,
    },
    {
      title: (
        <p style={{ lineHeight: 1.2 }}>
          판매유형
          <br />
          <small>(배송/렌탈/구독/금액권)</small>
        </p>
      ),
      dataIndex: 'type',
      key: 'type',
      width: 135,
      align: 'center',
      render: (v) => PRODUCT_TYPE[v]?.title,
    },
    {
      title: '베스트',
      dataIndex: 'best',
      key: 'best',
      width: 90,
      align: 'center',
      render: (item, record) => (
        <Switch
          checkedChildren={'진열'}
          unCheckedChildren={'숨김'}
          checked={item === 'Y' ? true : false}
          onChange={(checked) => onToggle(record.key, 'is_best', checked)}
        />
      ),
    },
    {
      title: '신상품',
      dataIndex: 'new',
      key: 'new',
      width: 90,
      align: 'center',
      render: (item, record) => (
        <Switch
          checkedChildren={'진열'}
          unCheckedChildren={'숨김'}
          checked={item === 'Y' ? true : false}
          onChange={(checked) => onToggle(record.key, 'is_new', checked)}
        />
      ),
    },
    {
      title: '브랜드',
      dataIndex: 'brand',
      key: 'brand',
      width: 90,
      align: 'center',
      render: (item, record) => (
        <Switch
          checkedChildren={'진열'}
          unCheckedChildren={'숨김'}
          checked={item === 'Y' ? true : false}
          onChange={(checked) => onToggle(record.key, 'is_show_brand', checked)}
        />
      ),
    },
    // {
    //   title: '모바일 할인가',
    //   dataIndex: 'm_sale',
    //   key: 'm_sale',
    //   render: (item) => stringToMoneyFormat(item),
    // },
    // {
    //   title: 'URL',
    //   dataIndex: 'url',
    //   key: 'url',
    //   render: () => (<span></span>)
    // },
    {
      title: '등록일',
      dataIndex: 'created',
      key: 'created',
      width: 130,
      align: 'center',
    },
    {
      title: '판매상태',
      dataIndex: 'status',
      width: 85,
      align: 'center',
      render: (v) => {
        const { color, title } = PRODUCT_STATUS[v];
        return <Tag color={color}>{title}</Tag>;
      },
    },
    {
      title: '심사상태',
      dataIndex: 'application',
      width: 85,
      align: 'center',
      render: (v) => {
        const { color, title } = APPLICATION_STATUS[v];
        return <Tag color={color}>{title}</Tag>;
      },
    },
  ];

  /* ===== RENDER ===== */
  return (
    <>
      <Table
        // isChecked
        bordered
        size='small'
        pagination={{
          onChange: onPagination,
          current: pagenationInformation,
        }}
        scroll={{ x: 1450 }}
        // dataSource={productList?.slice(
        //   (currentPage - 1) * 10,
        //   (currentPage - 1) * 10 + 10
        // )}
        dataSource={productList}
        columns={col}
        //
        // virtual
        rowSelection={{
          type: 'checkbox',
          onSelect: (record, selected) =>
            onChecked(selected ? 'checked' : 'unchecked', record),
          onSelectAll: (selected, selectedRows) =>
            onChecked(selected ? 'all-checked' : 'all-unchecked', selectedRows),
          selectedRowKeys: checkedList?.map((item) => item?.key),
        }}
        //
        checkedAll={isCheckedAll}
        checkedList={checkedList}
        onChecked={onChecked}
        onCheckedAll={onCheckedAll}
      />

      {/* <Pagination
        current={currentPage}
        pageSize={10}
        total={productList?.length}
        onChange={(e) => onPagination(e)}
        style={{ marginTop: 15 }}
      /> */}
    </>
  );
};

const StyledRow = styled.tr`
  height: 50px; // 행 높이 고정
`;

export default ProductList;
